import React, { useContext, useEffect } from 'react';
import { FORM_WIDGET_COMPONENTS } from '../../common/form/formConstants';
import { FormContainer } from '../../common/form/FormContainer';
import { FormContext } from '../../common/form/FormContext';
import FormItem from '../../common/form/FormItem';
import FormPanel from '../../common/form/FormPanel';
import FormWidget from '../../common/form/FormWidget';
import I18n from '../../common/i18n/I18n';
import { arrayToSelectLocationsLocalized, arrayToSelectOptionsLocalized, SelectTypeEnum } from '../attributes';
import { AllowedLocationTypesEnum } from './locationHelper';

export default function LocationFieldEditor() {
    const { setState } = useContext(FormContext);

    useEffect(() => {
        setState((prevVal) => {
            const desiredSelectTypeId =
                prevVal.selectType?.id ??
                (prevVal.isMultiSelect === undefined
                    ? SelectTypeEnum.multi
                    : prevVal.isMultiSelect
                      ? SelectTypeEnum.multi
                      : SelectTypeEnum.single);

            if (prevVal.selectType?.id === desiredSelectTypeId) {
                return prevVal;
            }

            return {
                ...prevVal,
                selectType: {
                    id: desiredSelectTypeId,
                    label: desiredSelectTypeId
                }
            };
        });
    }, [setState]);

    return (
        <FormPanel>
            <FormContainer>
                <FormItem>
                    <FormWidget name="label" label={<I18n token="common.label" />} />
                </FormItem>
                <FormItem>
                    <FormWidget name="group" label={<I18n token="common.group" />} />
                </FormItem>
                <FormItem>
                    <FormWidget
                        name="description"
                        component={FORM_WIDGET_COMPONENTS.textArea}
                        label={<I18n token="common.description" />}
                    />
                </FormItem>
                <FormItem>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.switch}
                        name="required"
                        label={<I18n token="common.required" />}
                    />
                </FormItem>
                <FormItem>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.chips}
                        name="selectType"
                        coerceChangeToArray
                        options={arrayToSelectOptionsLocalized(Object.values(SelectTypeEnum))}
                    />
                </FormItem>
                <FormItem>
                    <FormWidget
                        component={FORM_WIDGET_COMPONENTS.autocomplete}
                        name="allowedLocationTypes"
                        label={<I18n token="attributes.location.allowedLocationTypes" />}
                        options={arrayToSelectLocationsLocalized(Object.values(AllowedLocationTypesEnum))}
                        allowFreeForm={false}
                    />
                </FormItem>
            </FormContainer>
        </FormPanel>
    );
}
